import {
  RuleGroupProps,
  useRuleGroup,
  TestID,
  isRuleGroup,
} from "react-querybuilder";
import { Fragment } from "react";
import classNames from "classnames";

const PowersearchRuleGroupBodyComponents = (props: RuleGroupProps) => {
  const rg = useRuleGroup(props);
  const {
    schema: {
      controls: {
        combinatorSelector: CombinatorSelectorControlElement,
        inlineCombinator: InlineCombinatorControlElement,
        ruleGroup: RuleGroupControlElement,
        rule: RuleControlElement,
      },
    },
  } = rg;

  return (
    <Fragment>
      {rg.ruleGroup.rules.map((r, idx, { length: ruleArrayLength }) => {
        const thisPathMemo = rg.pathsMemo[idx];
        const thisPath = thisPathMemo.path;
        const thisPathDisabled =
          thisPathMemo.disabled || (typeof r !== "string" && r.disabled);
        const key = typeof r === "string" ? [...thisPath, r].join("-") : r.id;
        return (
          <Fragment key={key}>
            {idx > 0 && (
              <div
                className={classNames("flex", "items-center", "justify-start")}
              >
                <div
                  className={classNames(
                    "mx-2",
                    "text-gray-500",
                    "text-center",
                    "text-sm",
                    "italic",
                  )}
                >
                  {rg.ruleGroup.combinator}
                </div>
              </div>
            )}
            {typeof r === "string" ? (
              <InlineCombinatorControlElement
                key={`${TestID.inlineCombinator}-independent`}
                options={rg.schema.combinators}
                value={r}
                title={rg.translations.combinators.title}
                className={rg.classNames.combinators}
                // oxlint-disable-next-line jsx-no-new-function-as-prop
                handleOnChange={(val) =>
                  rg.onIndependentCombinatorChange(val, idx)
                }
                rules={rg.ruleGroup.rules}
                level={rg.path.length}
                context={rg.context}
                validation={rg.validationResult}
                component={CombinatorSelectorControlElement}
                path={thisPath}
                disabled={thisPathDisabled}
                schema={rg.schema}
              />
            ) : isRuleGroup(r) ? (
              <RuleGroupControlElement
                key={TestID.ruleGroup}
                id={r.id}
                schema={rg.schema}
                actions={rg.actions}
                path={thisPath}
                translations={rg.translations}
                ruleGroup={r}
                disabled={thisPathDisabled}
                parentDisabled={rg.parentDisabled || rg.disabled}
                context={rg.context}
              />
            ) : (
              <RuleControlElement
                key={TestID.rule}
                id={r.id!}
                rule={r}
                schema={rg.schema}
                actions={rg.actions}
                path={thisPath}
                disabled={thisPathDisabled}
                parentDisabled={rg.parentDisabled || rg.disabled}
                translations={rg.translations}
                context={rg.context}
              />
            )}
          </Fragment>
        );
      })}
    </Fragment>
  );
};

export default PowersearchRuleGroupBodyComponents;
